import { createContentPropTypes } from '../../../helpers/content';

const content = {
	header: 'Add new payee',
	editPayeeHeader: 'Edit payee',
	subheader: 'Who would you like to pay?',
	nameDescription:
		"We'll ask their bank if the name matches what you've entered. You only need one name for a joint account.",
	addInternationalPayeeHeader: 'Add new international payee',
	payeeDetailsTitle: 'Payee details',
	accountsLabel: 'Choose one of your accounts to link this payee to',
	accountsDescription: "You'll still be able to move money to this payee from your other accounts.",
	nameLabel: 'Name on account',
	businessNameLabel: 'Business name',
	businessNameDescription:
		"We'll ask their bank if the name matches what you've entered. Trading names might not match - an invoice should show the account name.",
	sortCodeLabel: 'Sort code',
	accountNumberLabel: 'Account number',
	referenceLabel: 'Reference',
	editPayeeLabel: 'Update details',
	referenceDescription:
		'They’ll see this. You can add customer references, credit card or roll numbers here (if you have them).',
	saveInPayeeListLabel: 'Save in payee list',
	moreInfoText:
		'Keep these details so you don’t have to enter them again and again. Saving this payee in your secure payee list could also help reduce the steps required to authorise future payments to them (payment approval limits will still apply).',
	saveInPayeeListDescription: 'Save time and hassle when making and authorising payments to this payee.',
	displayNameLabel: 'Nickname',
	displayNameDescription: 'Only you’ll see this.',
	backButtonLabel: 'Back',
	cancelButtonLabel: 'Cancel',
	continueButtonText: 'Continue',
	saveButtonLabel: 'Save',
	addPayeeLabel: 'Add payee',
	linkAccountSelectCardTitle: 'Select an account',
	linkAccountErrorMessage: 'Choose an account to link this payee to then try again.',
	nameErrorMessage: 'Please enter the name of the person or company you want to add.',
	sortCodeErrorMessage: 'Please enter their six-digit sort code.',
	accountNumberErrorMessage: 'Please enter their eight-digit account number.',
	referenceErrorMessage: 'Please enter a reference for this payment.',
	displayNameErrorMessage: 'Please enter a nickname for this payee.',
	duplicatePayeeErrorMessage:
		"It looks like you've added these payment details before. Check the details you've entered and try again or choose this person or company from the list of who you pay.",
	payeeAddressTitle: 'Payee address',
	addressLineLabel: 'Address',
	addressLine1Label: 'Address line 1',
	payeeAddressLine1ErrorMessage: "Please enter the first line of the payee's address.",
	bankAddressLine1ErrorMessage: "Please enter the first line of the bank's address.",
	addressLine2Label: 'Address line 2 (optional)',
	cityLabel: 'City or town',
	payeeCityErrorMessage: 'Please enter the city or town that the payee lives in.',
	bankCityErrorMessage: 'Please enter the city or town that the bank is located in.',
	postalCodeLabel: 'Postcode',
	postalCodeDescription: "Please enter the payee's postal code, for example their postcode or ZIP code.",
	countryLabel: 'Country',
	payeeCountryErrorMessage: 'Please select one of the options to continue.',
	bankCountryErrorMessage: 'Please select one of the options to continue.',
	paymentDetailsTitle: 'Payment details',
	payeeAccountLabel: 'What account details do you have?',
	payeeAccountDescription:
		"The type of bank account number you require will depend on the country you're making the payment to. This should be provided by your payee.",
	IBANLabel: 'IBAN',
	IBANErrorMessage:
		"The format of the IBAN you've entered doesn't seem right. Please check the IBAN, remove any spaces between the characters, then try again.",
	internationalAccountNumberErrorMessage: "Please enter the payee's account number.",
	paymentReasonLabel: 'Reason for payment (optional)',
	paymentReasonDescription:
		'Please provide a detailed description of this payment. This can be added now or completed when it comes to making a payment. This can be edited each time a payment is made to this payee.',
	BICOrSWIFTLabel: 'BIC or SWIFT code',
	BICOrSWIFTDescription:
		'A bank identifier code (BIC) \u2013  also known as a SWIFT code \u2013 is a code that identifies banks and financial institutions worldwide.',
	BICOrSWIFTErrorMessage:
		'Please enter a valid BIC or SWIFT code. This should be either eight or 11 characters long and should only contain letters or numbers.',
	clearingCodeLabel: 'Clearing code (where required)',
	clearingCodeDescription:
		'A clearing code helps identify a bank branch in a country. This code (for example, an ABA, BSB or routing number) should be entered if provided by your payee. This is recommended for payments to Australia, Canada and the US.',
	noBicOrSwiftLabel: "I don't know this code",
	bankDetailsTitle: 'Bank details',
	bankNameLabel: 'Bank name',
	bankNameErrorMessage: "Please enter the name of the payee's bank.",
	internationalPayeeAccountInfoHeader: 'Do you need an IBAN or account number?',
	internationalPayeeAccountInfoTitle1: 'IBAN (International Bank Account Number)',
	internationalPayeeAccountInfoBodyPart1: [
		'An IBAN is an international standard for identifying bank accounts in many countries across the world and it makes it quicker, simpler and safer to send money abroad.',
		"It's mandatory to provide an IBAN in most European countries and a number of other countries throughout the world. The countries that require an IBAN are listed below.",
	],
	ibanMandatoryCountriesLabel: 'Countries that require an IBAN',
	internationalPayeeAccountInfoTitle2: 'Account number',
	internationalPayeeAccountInfoBodyPart2: [
		"An account number can be used to make payments to countries that don't require an IBAN, for example Australia, Canada, China, New Zealand and the US.",
		"If you're making a payment to Australia, Canada or the US, you're also recommended to enter a clearing code.",
	],
	chapsPaymentsEnableLabel: 'Make CHAPS payments to this payee',
	chapsReferenceLabel: 'CHAPS reference (optional)',
	chapsReferenceDescription:
		"If you're providing additional information here, please repeat the Reference you have already given us.",
	chapsReferenceError:
		"Sorry, the CHAPS reference for a CHAPS payment can't be more than 140 characters. Please go back and reduce the length of the CHAPS reference to make CHAPS payments to this payee.",
	otherPaymentReferenceLabel: 'Other payment reference',
	otherPaymentReferenceDescription:
		'Add a brief description to be used when any other type of payment is made. This reference can be edited each time a payment is made to this payee.',
	otherPaymentReferenceMaxLengthError:
		"Sorry, the other payment reference for a CHAPS payment can't be more than 18 characters. Please go back and reduce the length of the other payment reference to make CHAPS payments to this payee.",
	otherPaymentReferenceRequiredError: 'Please enter a reference for this payee.',
	chapsPayeeNameMaxlengthError:
		" Sorry, the payee name for a CHAPS payment can't be more than 33 characters. Please go back and reduce the length of the payee name to make CHAPS payments to this payee.",
	countryRequiresIBANErrorMessage:
		"Sorry, it looks like the payee's bank is in a country that requires an IBAN. Please select IBAN and enter this to continue. If you don't have an IBAN, the payee should be able to get it for you.",
	clearingCodeRequiredMessage:
		'Please provide a valid Bank Clearing Code (BCC) for the receiving bank of your payee. If you don’t have this, the Payee can provide it.',
	editChapsLabel: 'Update details',
	editChapsHeader: 'Edit CHAPS info',
	referenceInvalidCharsErrorMessage: 'You can only use the following special characters / & ( ) . , ‘ - ',
	swiftReferenceInvalidCharsErrorMessage: 'You can only use the following special characters / ? : ( ) . , ‘ + -',
};

export const contentPropTypes = createContentPropTypes(content);

export default content;
